// Shared runtime compile-recovery helpers for main and worker paths.
// Example: debug-off retries can rewrite legacy placeholders and emit one warning.
import type { LuisCompileWarning } from '@lentystyle/compiler'
import { buildFailSoftRecoverySource } from './fail-soft'
import { buildLegacyPlaceholderRecoverySource } from './fail-soft-placeholders'
import type { FailSoftRecoveryResult } from './fail-soft-types'

// Resolve one supported recovery payload for the current compile error.
/** @internal Resolve one supported recovery payload for the current compile error. */
export function resolveCompileRecoverySource(source: string, error: unknown): FailSoftRecoveryResult | null {
  const structuralRecovery = buildFailSoftRecoverySource(source, error)

  // Return structural-brace recovery when available.
  if (structuralRecovery) {
    // Return the structural recovery payload.
    return structuralRecovery
  }

  // Return legacy-placeholder recovery when available.
  return buildLegacyPlaceholderRecoverySource(source, error)
}

// Append one compiler-compatible warning for a successful recovery retry.
/** @internal Append one compiler-compatible warning for a successful recovery retry. */
export function pushCompileRecoveryWarning(
  warnings: LuisCompileWarning[],
  sourceId: string,
  recovery: FailSoftRecoveryResult,
): void {
  warnings.push({
    code: 'invalid-syntax',
    line: recovery._line,
    message: `[${sourceId}] ${recovery._message}`,
  })
}
